export default __webpack_public_path__ + "static/box-458d345ea3b09a3e059389d421acd542.png";